import { nearestSixteenth } from '@rta/rta-blueprint-library';

export const getDimensionMeasurement = (num: number, useFraction: boolean): string => {
	const rounded = nearestSixteenth(num);
	const wholeNumber = Math.trunc(rounded);
	const decimal = rounded - wholeNumber;

	// If the value does not fall cleanly on a 1/16" increment (e.g., irrational
	// sqrt(2) values from 45-degree corner joints), display with 3 decimal places
	// instead of forcing it to the nearest sixteenth.
	if (Math.abs(num - rounded) > 0.001) {
		return num.toFixed(3);
	}

	if (decimal > 0 && useFraction) {
		const wholeNumberString = wholeNumber === 0 ? '' : `${wholeNumber} `;
		const sixteenths = decimal / 0.0625;
		const denominator = sixteenths % 8 ? sixteenths % 4 ? sixteenths % 2 ? 16 : 8 : 4 : 2;
		const numerator = denominator === 16 ? sixteenths : sixteenths * denominator / 16;
		return `${wholeNumberString}${numerator}\u2044${denominator}`;
	}

	return rounded.toString();
};
